import { CALL_API } from '../../api';
import * as ActionTypes from './content.actionTypes';
import schema from '../../api/schema';

const apiReadContents = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CONTENTS_REQUEST,
      ActionTypes.READ_CONTENTS_SUCCESS,
      ActionTypes.READ_CONTENTS_FAILURE,
    ],
    endpoint: 'pages.json',
    schema: schema.contentsSchema,
    //authorization: true,
  },
});

export const readContents = () => (dispatch, getState) => {
  //TODO
  /*
  if (getState().entities.content.allIds.length > 0) {
    return Promise.resolve();
  }
  */
  return dispatch(apiReadContents());
};

const apiReadContent = slug => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CONTENT_REQUEST,
      ActionTypes.READ_CONTENT_SUCCESS,
      ActionTypes.READ_CONTENT_FAILURE,
    ],
    endpoint: `pages/${slug}`,
    schema: schema.contentSchema,
    //authorization: true,
  },
});

export const readContent = slug => (dispatch, getState) => {
  if (getState().entities.content.byId.slug) {
    return Promise.resolve();
  }
  return dispatch(apiReadContent(slug));
};



// WEBPACK FOOTER //
// ./src/modules/content/content.actions.js